<template>
  <el-table :data="tableData" v-loading="loading" stripe style="width: 100%;">
    <el-table-column
      prop="preview"
      :label="$t('attr_value_gallery_table_main')"
      width="90"
      align="center"
    >
      <template slot-scope="scope">
        <input
          type="radio"
          :checked="scope.row.preview"
          @change="changePreview(scope.row)"
        />
      </template>
    </el-table-column>

    <el-table-column
      prop="url"
      width="100"
      align="center"
      :label="$t('attr_value_gallery_table_photo')"
    >
      <template slot-scope="scope">
        <el-image
          style="width: 100px; height: 68px;"
          :src="scope.row.url"
          :preview-src-list="[scope.row.url]"
        >
        </el-image>
      </template>
    </el-table-column>

    <el-table-column
      prop="description"
      :label="$t('attr_value_gallery_table_description')"
    >
      <template slot-scope="scope">
        <el-input
          v-model="scope.row.description[currentLanguage]"
          @change="changeDescription(scope.row)"
        ></el-input>
      </template>
    </el-table-column>

    <el-table-column
      prop="numberInOrder"
      width="145"
      align="center"
      :label="$t('attr_value_gallery_table_order_num')"
    >
      <template slot-scope="scope">
        <el-input-number
          v-model="scope.row.numberInOrder"
          :min="0"
          @change="changeOrderNum(scope.row, scope.$index)"
        ></el-input-number>
      </template>
    </el-table-column>

    <el-table-column
      fixed="right"
      :label="$t('attr_value_gallery_table_operation')"
      width="120"
      align="center"
    >
      <template slot-scope="scope">
        <el-button
          type="primary"
          icon="el-icon-edit"
          :title="$t('attribute_templates_edit_title')"
          @click="changeAttribute(scope.row)"
        ></el-button>

        <el-button
          type="warning"
          icon="el-icon-delete"
          :title="$t('attribute_templates_delete_title')"
          @click="deleteRow(scope.row)"
        ></el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import * as galleryService from "@/domain/object/gallery.service";
import { clone } from "@/domain/system/utils";

export default {
  name: "ObjectGalleryList",
  components: {},
  props: {
    loading: Boolean
  },
  data() {
    return {
      tableData: []
    };
  },
  computed: {
    ...mapState({
      gallery: state => state.objectComplexValue.galleryList.gallery,
      currentLanguage: state => state.objectSetting.currentLanguage
    })
  },
  methods: {
    ...mapMutations([
      "updateGalleryItem",
      "setGalleryList",
      "appendFilesToDelete",
      "deleteGalleryObject",
      "resetPreview",
      "setUrlEditable"
    ]),
    deleteRow(row) {
      this.$confirm(
        this.$t("object_remove_confirm_message", {
          name: row.description[this.currentLanguage]
        }),
        this.$t("object_remove_confirm_title"),
        {
          confirmButtonText: this.$t("object_remove_confirm_ok"),
          cancelButtonText: this.$t("object_remove_confirm_cancel"),
          type: "warning"
        }
      ).then(() => {
        this.appendFilesToDelete(row.url);
        this.deleteGalleryObject(row.url);
        if (row.preview) {
          this.setFirstItemPreview();
        }
        this.changeEmited();
      });
    },
    setFirstItemPreview() {
      if (this.gallery.length > 0) {
        this.changePreview(this.gallery[0]);
      }
    },
    changeAttribute(row) {
      this.setUrlEditable(row.url);
      this.changeEmitedInModalForm();
    },
    changeEmitedInModalForm() {
      this.$emit("changeInModalForm");
    },
    changeEmited() {
      this.$emit("change");
    },
    changePreview(row) {
      this.resetPreview();

      this.updateGalleryItem({
        url: row.url,
        fieldName: "preview",
        value: true
      });

      this.setTableData();

      this.changeEmited();
    },
    changeDescription(row) {
      this.updateGalleryItem({
        url: row.url,
        fieldName: `description.${this.currentLanguage}`,
        value: row.description[this.currentLanguage]
      });

      this.setTableData();

      this.changeEmited();
    },
    changeOrderNum(row, index) {
      this.setGalleryList(
        galleryService.recalcGalleryOrderNum(
          this.tableData.map(t => clone(t)),
          index
        )
      );

      this.setTableData();

      this.changeEmited();
    },
    setTableData() {
      this.tableData = [];
      this.$nextTick(function () {
        this.tableData = this.gallery.map(g => clone(g));
      });
    }
  },
  mounted() {
    this.setTableData();
  },
  watch: {
    gallery: function () {
      this.setTableData();
    }
  }
};
</script>

<style lang="scss" scoped></style>
